import { FrameName } from "../config";
import AbstractSalvageableFightableEnemyTileEntity from "./AbstractSalvageableFightableEnemyTileEntity";

class ShallowSeaRaidersGalleySalvageableTileEntity extends AbstractSalvageableFightableEnemyTileEntity {
	public static readonly frameName = FrameName.SHALLOW_SEA_RAIDERS_GALLEY;
}

export default ShallowSeaRaidersGalleySalvageableTileEntity;
